export const inputCls = "w-full border-2 border-black px-3 py-2 font-mono-data rounded-none focus:outline-none focus:ring-2 focus:ring-[#0000EE]";
export const selectCls = "w-full border-2 border-black px-3 py-2 font-mono-data bg-white rounded-none";

export function Field({ label, required, children }) {
  return (
    <label className="block">
      <span className="font-mono-data text-xs uppercase font-bold block mb-1">
        {label}{required && <span className="text-[#FF0000] ml-1">*</span>}
      </span>
      {children}
    </label>
  );
}
